import { render, staticRenderFns } from "./EditPayrateModal.vue?vue&type=template&id=0a1b72c8&scoped=true&"
import script from "./EditPayrateModal.vue?vue&type=script&lang=js&"
export * from "./EditPayrateModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPayrateModal.vue?vue&type=style&index=0&id=0a1b72c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b72c8",
  null
  
)

export default component.exports